import { render, staticRenderFns } from "./SplitTruckView.vue?vue&type=template&id=4ee8afb2&scoped=true"
import script from "./SplitTruckView.vue?vue&type=script&lang=ts"
export * from "./SplitTruckView.vue?vue&type=script&lang=ts"
import style0 from "./SplitTruckView.vue?vue&type=style&index=0&id=4ee8afb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee8afb2",
  null
  
)

export default component.exports